import React from 'react'
import Table from 'react-bootstrap/Table'
import DiscThumb from './DiscThumb'
import FlightNumbers from './FlightNumbers'
import { discTypeName } from './discModel'

// Shared table of discs, used by both "My Discs" and a bag's detail view.
function DiscsList({ discs = [] }) {
  if (discs.length === 0) {
    return <p className="discs-empty">No discs here yet.</p>
  }

  return (
    <Table hover className="discs-table">
      <thead>
        <tr>
          <th></th>
          <th>Name</th>
          <th>Type</th>
          <th>Flight</th>
          <th>Brand</th>
          <th>Plastic</th>
          <th>Weight</th>
        </tr>
      </thead>
      <tbody>
        {discs.map((disc) => (
          <tr
            key={disc.uuid}
            className={`discs-table-row${disc.l ? ' is-lost' : ''}`}
          >
            <td className="discs-table-col discs-table-col-thumb">
              <DiscThumb disc={disc} />
            </td>
            <td className="discs-table-col discs-table-col-name">
              {disc.nm}
              {disc.l && <span className="disc-lost-badge">Lost</span>}
            </td>
            <td className="discs-table-col discs-table-col-type">
              {discTypeName(disc.to)}
            </td>
            <td className="discs-table-col discs-table-col-flight">
              <FlightNumbers disc={disc} />
            </td>
            <td className="discs-table-col discs-table-col-brand">{disc.b}</td>
            <td className="discs-table-col discs-table-col-plastic">{disc.p}</td>
            <td className="discs-table-col discs-table-col-weight">
              {disc.w ? `${disc.w} g` : ''}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default DiscsList
